import {AvatarStack} from '@primer/react'
import {graphql, usePaginationFragment} from 'react-relay'

import type {Assignees$key} from './__generated__/Assignees.graphql'
import {Assignee} from './Assignee'
import styles from './Assignees.module.css'

type assigneesProps = {
  assigneeskey: Assignees$key
  /**
   * Href getter for the assignee badge links
   * @param name - name of the assignee
   * @returns URL to the assignee
   */
  getAssigneeHref: (assignee: string) => string
}

export function Assignees({assigneeskey, getAssigneeHref}: assigneesProps) {
  const {data} = usePaginationFragment(
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    graphql`
      fragment Assignees on Assignable
      @argumentDefinitions(assigneePageSize: {type: "Int"}, cursor: {type: "String"})
      @refetchable(queryName: "IssueAssigneePaginatedQuery") {
        assignedActors(first: $assigneePageSize, after: $cursor) @connection(key: "IssueAssignees_assignedActors") {
          edges {
            node {
              __typename
              ... on Actor {
                __typename
                id
                login
                # eslint-disable-next-line relay/unused-fields - used by similar fragments, needed here too
                name
                # eslint-disable-next-line relay/unused-fields - used by similar fragments, needed here too
                profileResourcePath
                # eslint-disable-next-line relay/unused-fields - used by similar fragments, needed here too
                avatarUrl(size: 64)
                ... on Bot {
                  isCopilot
                  isAgent
                  displayName
                }
              }
            }
          }
        }
      }
    `,
    assigneeskey,
  )
  const assignees = (data.assignedActors?.edges || []).flatMap(a => (a && a.node ? a.node : []))

  if (!assignees.length) {
    return null
  }

  return (
    <AvatarStack alignRight className={styles.AssigneesAvatarStack}>
      {assignees.map(assignee => (
        <Assignee
          key={assignee.id}
          login={assignee.login || ''}
          avatarUrl={assignee.avatarUrl || ''}
          isCopilot={assignee.isCopilot || false}
          isAgent={assignee.isAgent || false}
          displayName={assignee.displayName}
          getAssigneeHref={getAssigneeHref}
        />
      ))}
    </AvatarStack>
  )
}
